/**
 * JS for single collection
 */

import * as lpUtils from '../utils.js';

// Rest API Enroll Collection
const enrollCollection = ( e, target ) => {
	e.preventDefault();

	if ( ! target.classList.contains('lp-form-collection-enroll') ) {
		return;
	}

	const btnEnroll = target.querySelector( '.lp-btn-collection-enroll' );
	const formData = new FormData( target )
	const dataSend = {
		action: 'enroll_collection',
		args: {
			id_url: 'enroll-collection',
		},
	};

	for ( const [key, value] of formData.entries() ) {
		if ( ! dataSend.hasOwnProperty( key ) ) {
			let value_convert = value;
			if ( 'object' === typeof value ) {
				value_convert = value.join( ',' );
			}
			dataSend[ key ] = value_convert;
		}
	}

	// AJax enroll collection
	const callBack = {
		success: ( response ) => {
			const {
				status,
				data: { redirect },
				message,
			} = response;

			if( btnEnroll ) {
				btnEnroll.remove();
			}

			if ( message && status ) {
				target.innerHTML += `<div class="learn-press-message ${ status }">${ message }</div>`;
				if ( redirect ) {
					window.location.href = redirect;
				}
			}
		},
		error: ( error ) => {
			console.log( error );
		},
		completed: () => {
		},
	};

	lpUtils.lpSetLoadingEl( btnEnroll, 1 );
	window.lpAJAXG.fetchAJAX( dataSend, callBack );
};

document.addEventListener( 'submit', ( e ) => {
	const target = e.target;
	enrollCollection( e, target );
} );

export class CollectionCourseBrowser {
	static selectors = {
		browser: '.lp-collection-courses',
		target: '.lp-target',
		orderBy: '.collection-courses-order-by',
		layoutInput: 'input[name="lp-collection-switch-layout-btn"]',
		courseList: '.collection-course-browser',
	};

	constructor() {
		this.handleChange = this.handleChange.bind( this );
		// Prevent the archive-course handler from issuing a competing AJAX request.
		document.addEventListener( 'change', this.handleChange, true );
	}

	handleChange( event ) {
		if ( ! ( event.target instanceof Element ) ) {
			return;
		}

		const browser = event.target.closest( CollectionCourseBrowser.selectors.browser );
		if ( ! browser ) {
			return;
		}

		if ( event.target.matches( CollectionCourseBrowser.selectors.orderBy ) ) {
			event.stopImmediatePropagation();
			this.updateOrderBy( event.target );
			return;
		}

		if ( event.target.matches( CollectionCourseBrowser.selectors.layoutInput ) ) {
			event.stopImmediatePropagation();
			this.updateLayout( event.target );
		}
	}

	updateOrderBy( select ) {
		const target = select.closest( CollectionCourseBrowser.selectors.target );
		const dataSend = this.getDataSend( target );
		if ( ! target || ! dataSend ) {
			return;
		}

		dataSend.args.order_by = select.value;
		dataSend.args.paged = 1;
		this.updateUrl( dataSend.args );
		this.loadCourses( target, dataSend );
	}

	updateLayout( input ) {
		const target = input.closest( CollectionCourseBrowser.selectors.target );
		const dataSend = this.getDataSend( target );
		const courseList = input
			.closest( CollectionCourseBrowser.selectors.browser )
			?.querySelector( CollectionCourseBrowser.selectors.courseList );
		if ( ! target || ! dataSend || ! courseList ) {
			return;
		}

		dataSend.args.layout = input.value;
		target.dataset.send = JSON.stringify( dataSend );
		courseList.dataset.layout = input.value;
		this.updateUrl( dataSend.args );
	}

	getDataSend( target ) {
		if ( ! target?.dataset.send ) {
			return null;
		}

		try {
			return JSON.parse( target.dataset.send );
		} catch ( error ) {
			return null;
		}
	}

	loadCourses( target, dataSend ) {
		if ( ! window.lpAJAXG ) {
			window.location.reload();
			return;
		}

		target.dataset.send = JSON.stringify( dataSend );
		window.lpAJAXG.showHideLoading( target, 1 );
		window.lpAJAXG.fetchAJAX( dataSend, {
			success: ( response ) => {
				target.innerHTML = response.data?.content || response.message || '';
			},
			error: () => {},
			completed: () => {
				window.lpAJAXG.showHideLoading( target, 0 );
			},
		} );
	}

	updateUrl( args ) {
		const url = new URL( window.location.href );
		[ 'order_by', 'layout', 'paged' ].forEach( ( key ) => {
			if ( args[ key ] ) {
				url.searchParams.set( key, args[ key ] );
			}
		} );

		if ( window.lpData?.urlParams ) {
			Object.assign( window.lpData.urlParams, {
				order_by: args.order_by,
				layout: args.layout,
				paged: args.paged,
			} );
		}

		window.history.pushState( {}, '', url );
	}
}

new CollectionCourseBrowser();
